import React, { Component } from 'react';
import firebase from 'firebase';
import { Pulse } from 'react-preloading-component';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import ReactExport from "react-data-export";
import store from '../../store';
import { getAuth } from '../config/Paths';
import moment from 'moment';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

function formatDate(dateString) {
	const date = new Date(dateString);
	const day = String(date.getDate()).padStart(2, '0');
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const year = date.getFullYear();
	return `${day}/${month}/${year}`;
}

function formatNumero(numero) {
	return numero === 0 ? '0' : numero;
}

class ReporteOperacionalO extends Component {
	constructor(props) {
		super(props);
		this.state = {
			clienteR: [],
			centroR: [],
			ViajesR: [],
			empleadosR: [],
			vehiculosR: [],
			empresaR: [],
			tarifas: [],
			programaciones: [],
			DetalleViaje: [],
			empreUID: 'GudI9QD16ceP2Z2df28KVMeNI7h2', // Valor por defecto
			isLoading: true,
			fecha_desde: '',
			fecha_hasta: '',
			isPulse: false,
			empresas: [] // Añadido para almacenar las empresas
		};
		this.handleChangeDatePicker1 = this.handleChangeDatePicker1.bind(this);
		this.handleChangeDatePicker2 = this.handleChangeDatePicker2.bind(this);
		this.handleChangeEmpresa = this.handleChangeEmpresa.bind(this); // Nuevo
	}

	componentDidMount() {
		const curr = new Date();
		const date = curr.toLocaleDateString('en-CA'); // Formato 'YYYY-MM-DD'
		this.setState({ fecha_desde: date, fecha_hasta: date }, this.getData); // Llama a getData después de establecer las fechas
		this.getEmpresas();
	}

	componentDidUpdate(prevProps, prevState) {
		// Verifica si las fechas o empreUID han cambiado para volver a cargar los datos
		if (
			(prevState.fecha_desde !== this.state.fecha_desde && this.state.fecha_desde) ||
			(prevState.fecha_hasta !== this.state.fecha_hasta && this.state.fecha_hasta) ||
			prevState.empreUID !== this.state.empreUID
		) {
			this.setState({ isPulse: true }, this.getData);
		}
	}

	getEmpresas() {
		firebase.database().ref('Empresa').on('value', data => {
			let empresas = [];
			data.forEach(element => {
				let k = element.key;
				let valores = element.val();
				let name = valores.codigo_empresa;
				empresas.push({
					key: k,
					nombre: name
				});
			});
			this.setState({ empresas });
		});
	}

	handleChangeEmpresa(event) {
		this.setState({ empreUID: event.target.value });
	}

	getData = () => {
		let { empreUID, fecha_desde, fecha_hasta } = this.state;

		if (!fecha_desde || !fecha_hasta) {
			console.error('Las fechas no están definidas.');
			return;
		}

		let fecha1 = new Date(fecha_desde);
		fecha1.setDate(fecha1.getDate() + 1);
		fecha1.setHours(0, 0, 0, 0);

		let fecha2 = new Date(fecha_hasta);
		fecha2.setDate(fecha2.getDate() + 1);
		fecha2.setHours(23, 59, 59, 999);

		let fechasEnMilisegundos = [];
		for (let d = fecha1; d <= fecha2; d.setDate(d.getDate() + 1)) {
			fechasEnMilisegundos.push(new Date(d).getTime());
		}

		let fechasEnFormatoRequerido = fechasEnMilisegundos.map(ms => {
			let fecha = new Date(ms);
			return fecha.toString();
		});

		this.setState({ isLoading: true });

		let promises = [];

		promises.push(
			firebase.database().ref().child('AsignacionViajes')
				.orderByChild('fecha')
				.once('value')
				.then(snapV => {
					let datosV = [];
					snapV.forEach(elementCli => {
						let objeC = elementCli.val();
						if (objeC.fecha !== undefined && fechasEnFormatoRequerido.includes(objeC.fecha)) {
							objeC.key = elementCli.key;
							datosV.push(objeC);
						}
					});
					datosV.sort((a, b) => new Date(a.fecha) - new Date(b.fecha)); // Ordenar por fecha
					this.setState({ ViajesR: datosV });
				})
		);

		promises.push(
			firebase.database().ref('Empleados').once('value').then(snapE => {
				let datosE = [];
				snapE.forEach(elementCli => {
					let objeC = elementCli.val();
					objeC.key = elementCli.key;
					datosE.push(objeC);
				});
				this.setState({ empleadosR: datosE });
			})
		);

		promises.push(
			firebase.database().ref('Vehiculos').once('value').then(snapVe => {
				let datosVe = [];
				snapVe.forEach(elementCli => {
					let objeC = elementCli.val();
					objeC.key = elementCli.key;
					datosVe.push(objeC);
				});
				this.setState({ vehiculosR: datosVe });
			})
		);

		promises.push(
			firebase.database().ref().child('Clientes').orderByChild('socio').equalTo(empreUID).once('value').then(snapC => {
				let datosC = [];
				snapC.forEach(elementCli => {
					let objeC = elementCli.val();
					objeC.key = elementCli.key;
					datosC.push(objeC);
				});
				this.setState({ clienteR: datosC });
			})
		);

		promises.push(
			firebase.database().ref().child('CentroCosto').orderByChild('empresa').equalTo(empreUID).once('value').then(snapCo => {
				let datosCo = [];
				snapCo.forEach(elementCli => {
					let objeC = elementCli.val();
					objeC.key = elementCli.key;
					datosCo.push(objeC);
				});
				this.setState({ centroR: datosCo });
			})
		);

		promises.push(
			firebase.database().ref('Empresa/' + empreUID).once('value').then(snapEmp => {
				let empresa = snapEmp.val();
				this.setState({ empresaR: empresa });
			})
		);

		promises.push(
			firebase.database().ref('TarifasAvianca').once('value').then(snapTarifas => {
				let tarifas = [];
				snapTarifas.forEach(elementTar => {
					let objeT = elementTar.val();
					objeT.key = elementTar.key;
					tarifas.push(objeT);
				});
				this.setState({ tarifas });
			})
		);

		promises.push(
			firebase.database().ref('Programacion').once('value').then(snapP => {
				let programaciones = [];
				snapP.forEach(elementPro => {
					let progra = elementPro.val();
					progra.key = elementPro.key;
					programaciones.push(progra);
				});
				this.setState({ programaciones });
			})
		);

		promises.push(
			firebase.database().ref('DetalleViaje').once('value').then(snapDe => {
				let DetalleViaje = [];
				snapDe.forEach(elementDeta => {
					let progra = elementDeta.val();
					progra.key = elementDeta.key;
					DetalleViaje.push(progra);
				});
				this.setState({ DetalleViaje });
			})
		);

		Promise.all(promises).then(() => {
			let { clienteR, centroR } = this.state;
			if (clienteR.length === 0 && centroR.length === 0) {
				this.setState({
					viajes: [],
					viajestemp: [],
					isLoading: false,
					isPulse: false
				});
				console.log('No hay datos para la empresa seleccionada.');
			} else {
				this.setState({ isLoading: false, isPulse: false }, () => {
					this.cargarViajesEmpresariales();
				});
			}
		}).catch(error => {
			console.error('Error al cargar los datos:', error);
			this.setState({ isLoading: false, isPulse: false });
		});
	};

	cargarViajesEmpresariales = () => {
		let { clienteR, centroR, ViajesR, empleadosR, vehiculosR, empresaR, tarifas, programaciones, DetalleViaje } = this.state;

		let mostrar = [];
		for (let index = 0; index < ViajesR.length; index++) {
			let viajes = ViajesR[index];
			[viajes.emple].forEach(element => {
				let cantidadP = Object.keys(element).length;
				let encontrardoConduct = '';
				let costo = '';
				let area = [];
				let responsable = '';
				let encontrardoVehiculo = '';
				let encontradotarifas = '';
				let encontradoProgra = '';
				let clientesN = [];
				let fechaI = '---';
				let fechaA = [];
				let fechaB = [];
				let fechaF = '---';
				let desde = '';
				let hacia = [];
				let tarifaA = '---';
				let precioA = '---';
				let Solicito = '';
				let codClie = [];
				let fechaFti = '';
				let fechaIti = '';
				let suma = 0;
				let validos = [];
				let velocidadP = 0;
				desde = viajes.inicio;
				let fInicial = new Date(viajes.horaIni);
				let fFinal = new Date(viajes.horaFin);
				if (viajes.horaIni !== '') {
					fechaI = fInicial.getHours() + ':' + fInicial.getMinutes();
				}
				if (viajes.horaFin) {
					fechaF = fFinal.getHours() + ':' + fFinal.getMinutes();
				}
				if (viajes.destino !== undefined) {
					hacia.push(viajes.destino);
				}
				for (let index = 0; index < cantidadP; index++) {
					let objeCli = element[Object.keys(element)[index]];//importante
					let encontrardoClie = clienteR.find(client => {
						return objeCli.idEmple === client.key;
					})
					if (encontrardoClie !== undefined) {
						clientesN.push(`${encontrardoClie.nombre} ${encontrardoClie.apellido}`)
						codClie.push(encontrardoClie.numero_empleado)
						area.push(encontrardoClie.areaDesc)
						let fecha1 = new Date(objeCli.horaSubida)
						fechaA.push(fecha1.getHours() + ':' + fecha1.getMinutes())
						let fecha2 = new Date(objeCli.horaBajada)
						if (isNaN(fecha2.getHours()) === false) {
							fechaB.push(fecha2.getHours() + ':' + fecha2.getMinutes())
						}
						if (viajes.destino === undefined) {
							hacia.push(objeCli.destino);
						}
						let encontrardoCosto = centroR.find(client => {
							return encontrardoClie.centro === client.key;
						})
					}
				}
				encontrardoConduct = empleadosR.find(emple => {
					return viajes.conduc === emple.key;
				})
				if (encontrardoConduct) {
					encontrardoVehiculo = vehiculosR.find(vehi => {
						return viajes.vehiculo === vehi.key;
					})

				}
				if (viajes.tarifa !== undefined && viajes.tarifa !== '') {
					encontradotarifas = tarifas.find(tari => {
						return viajes.tarifa === tari.key;
					})
					if (encontrardoVehiculo)
						precioA = encontradotarifas.valores[(encontrardoVehiculo.tipo_vehiculo == 'Privado') ? 'Ejecutivo' : encontrardoVehiculo.tipo_vehiculo];

					tarifaA = encontradotarifas.tipo;
				}
				if (viajes.prograP !== undefined && viajes.prograP !== '') {
					encontradoProgra = programaciones.find(costo => {
						return viajes.prograP === costo.key;
					})
					if (encontradoProgra !== undefined) {
						if (encontradoProgra.centroC !== undefined) {
							let encontrardoCosto = centroR.find(centro => {
								return encontradoProgra.centroC === centro.key;
							})
							costo = encontrardoCosto.codigo;
							responsable = encontrardoCosto.responsable;
						}
						fechaIti = encontradoProgra.horaReco;
						fechaFti = encontradoProgra.horaAero;
					}
				}
				let encontrardoDetalle = DetalleViaje.find(detalle => {
					return viajes.key === detalle.key;
				})

				if (encontrardoDetalle !== undefined) {
					if (encontrardoDetalle.velocidad) {
						Array.prototype.forEach.call(encontrardoDetalle.velocidad, element => {
							if (element != '0' && element != '00.00' && element != '0.00') {
								validos.push(element)
								suma = Number(suma) + Number(element);
							}
						});
						velocidadP = suma / validos.length.toFixed(2);
					}
				}
				if (encontrardoConduct) {
					if (encontrardoConduct.nombre !== "") {
						if (encontradoProgra.tipo !== "pilotossap" && encontradoProgra.tipo !== "tcssap") {
							let fecha_registro = new Date(viajes.fecha).toLocaleDateString();
							let objeT = {
								key: viajes.key,
								cliente: empresaR ? this.setUndefined(empresaR.codigo_empresa) : "",
								empleado: encontrardoConduct ? this.setUndefined(encontrardoConduct.nombre) : "",
								fechaReserva: this.setUndefined(fechaI),
								fechaBajada: this.setUndefined(fechaF),
								fechaSubida: this.setUndefined(fechaI),
								horaSubida: this.setUndefined(fechaA.join(',')),
								horaBajada: this.setUndefined(fechaB.join(',')),
								movil: this.setUndefined(viajes.movil),
								pago: this.setUndefined(tarifaA),
								total: this.setUndefined(precioA),
								tipoV: encontrardoConduct ? this.setUndefined(encontrardoConduct.tipo_vehiculo) : "",
								foto: encontrardoConduct ? this.setUndefined(encontrardoConduct.foto) : "",
								keyEmpleado: encontrardoConduct ? this.setUndefined(encontrardoConduct.key) : "",
								detaCate: '#N/A',
								areaDesc: this.setUndefined(area.join(',')),
								cantTrayec: this.setUndefined(cantidadP),
								numero: this.setUndefined(cantidadP),
								numero_empleado: this.setUndefined(cantidadP),
								centro: this.setUndefined(costo),
								responsable: this.setUndefined(responsable),
								vehiculo: encontrardoVehiculo ? this.setUndefined(encontrardoVehiculo.placa.replace(/-/, '')) : "",
								personas: this.setUndefined(clientesN.join(',')),
								numero_empleado: this.setUndefined(codClie.join(',')),
								desde: this.setUndefined(viajes.nameIni),
								lugar: this.setUndefined(viajes.nameDes),
								combinacion: this.setUndefined(viajes.nameIni) + '/' + this.setUndefined(viajes.nameDes),
								kmInicial: this.setUndefined(viajes.kmInicial),
								kmFinal: this.setUndefined(viajes.kmFinal),
								fecha: this.setUndefined(viajes.fecha),
								fechaRegistro: this.setUndefined(fecha_registro),
								fechaIti: this.setUndefined(fechaIti),
								fechaFti: this.setUndefined(fechaFti),
								velocidadP: isNaN(velocidadP) ? "" : this.setUndefined(velocidadP.toFixed(2)),
								comentario: this.setUndefined(viajes.comentario)
							}
							mostrar.push(objeT);
						}
					}
				}
			});
		};
		this.setState({
			viajes: mostrar,
			viajestemp: mostrar
		});

		this.handleChangeDatePicker2();
		let index = 0;
	}

	setUndefined = (datos) => {
		if (datos === undefined) {
			return '---'
		}
		else {
			return datos
		}
	}

	onChangeEmpresas(e) {
		this.setState({ empreUID: e.target.value });
	}

	ocultarMenu() {
		store.dispatch({
			type: 'STATE_MOSTRAR',
			mostrar: 'noMostrar'
		})
	}

	handleChangeDatePicker1 = (e) => {
		let fecha1 = this.fecha1.value;
		this.fecha2.value = '';
		this.setState({
			fecha_hasta: '',
			fecha_minima: fecha1,
			input_disabled: ''
		});
	};

	handleChangeDatePicker2 = async () => {
		let fecha1 = this.fecha1.value;
		let fecha2 = this.fecha2.value;

		let f1 = new Date(fecha1);
		let f2 = new Date(fecha2);

		f1.setDate(f1.getDate() + 1);
		f2.setDate(f2.getDate() + 1);

		//console.log(`Fecha desde: ${fecha1}, Fecha hasta: ${fecha2}`);

		// Verificar si las fechas han cambiado y si ambas fechas están definidas
		if (fecha1 && fecha2 && (fecha1 !== this.state.fecha_desde || fecha2 !== this.state.fecha_hasta)) {
			// Actualizar el estado con las nuevas fechas y mostrar la animación de carga
			this.setState({
				isLoading: true,
				fecha_desde: fecha1,
				fecha_hasta: fecha2
			}, async () => {
				// Llamar a getData después de actualizar el estado
				await this.getData();

				let newViajes = [];

				for (let i = 0; i < this.state.viajes.length; i++) {
					if (f2.toLocaleDateString() >= (new Date(this.state.viajes[i].fecha).toLocaleDateString()) && f1.toLocaleDateString() <= (new Date(this.state.viajes[i].fecha).toLocaleDateString())) {
						newViajes.push({
							key: this.state.viajes[i].key,
							cliente: this.state.viajes[i].cliente,
							empleado: this.state.viajes[i].empleado,
							fechaReserva: this.state.viajes[i].fechaReserva,
							fechaBajada: this.state.viajes[i].fechaBajada,
							fechaSubida: this.state.viajes[i].fechaSubida,
							horaSubida: this.state.viajes[i].horaSubida,
							horaBajada: this.state.viajes[i].horaBajada,
							movil: this.state.viajes[i].movil,
							pago: this.state.viajes[i].pago,
							total: this.state.viajes[i].total,
							tipoV: this.state.viajes[i].tipoV,
							foto: this.state.viajes[i].foto,
							keyEmpleado: this.state.viajes[i].keyEmpleado,
							detaCate: this.state.viajes[i].detaCate,
							areaDesc: this.state.viajes[i].areaDesc,
							cantTrayec: this.state.viajes[i].cantTrayec,
							numero: this.state.viajes[i].numero,
							numero_empleado: this.state.viajes[i].numero_empleado,
							centro: this.state.viajes[i].centro,
							responsable: this.state.viajes[i].responsable,
							vehiculo: this.state.viajes[i].vehiculo,
							personas: this.state.viajes[i].personas,
							numero_empleado: this.state.viajes[i].numero_empleado,
							desde: this.state.viajes[i].desde,
							lugar: this.state.viajes[i].lugar,
							combinacion: this.state.viajes[i].combinacion,
							kmInicial: this.state.viajes[i].kmInicial,
							kmFinal: this.state.viajes[i].kmFinal,
							fecha: moment(this.state.viajes[i].fecha).format('DD/MM/YYYY'),
							fechaFti: this.state.viajes[i].fechaFti,
							fechaIti: this.state.viajes[i].fechaIti,
							velocidadP: this.state.viajes[i].velocidadP,
							fechaRegistro: this.state.viajes[i].fechaRegistro,
							comentario: this.state.viajes[i].comentario
						});
					}
				}

				this.setState({
					viajes: newViajes,
					btndisabled: false,
					isLoading: false
				});
			});
		}
	}

	render() {
		const { viajes, empresaSelect, empresas, isLoading, isPulse, empreUID } = this.state;

		if (isLoading) {
			return <Pulse />
		}

		if (isPulse) {
			return <Pulse />
		}
		else {
			return (
				<div className="container" onClick={this.ocultarMenu}>
					<div className="row">
						<div className="col-md-6 col-sm-6 col-xs-6">
							<ExcelFile filename="Reporte_Viajes.xlsx" element={<button className="btn btn-success btn-sm excel"><span className="glyphicon glyphicon-download-alt"></span> Descargar Excel </button>}>
								<ExcelSheet data={(Array.isArray(viajes) ? viajes : []).map(viaje => ({
									...viaje,
									fecha: formatDate(viaje.fecha),
									numero: formatNumero(viaje.numero)
								}))} name="Viajes">
									<ExcelColumn label="Fecha de Registro" value="fecha" />
									<ExcelColumn label="Conductor" value="empleado" />
									<ExcelColumn label="Centro de costos" value="centro" />
									<ExcelColumn label="Area de descargue" value="areaDesc" />
									<ExcelColumn label="movil" value="movil" />
									<ExcelColumn label="Unidad" value="vehiculo" />
									<ExcelColumn label="Cantidad de personas por viaje" value="numero" />
									<ExcelColumn label="Nombres (pasajeros)" value="personas" />
									<ExcelColumn label="Hora inicio itinerada" value="fechaIti" />
									<ExcelColumn label="Hora inicio Real" value="fechaSubida" />
									<ExcelColumn label="Hora subida pasajeros" value="horaSubida" />
									<ExcelColumn label="Hora finalizacion itinerada" value="fechaFti" />
									<ExcelColumn label="Hora finalizacion Real" value="fechaBajada" />
									<ExcelColumn label="Pago" value="pago" />
									<ExcelColumn label="Desde" value="desde" />
									<ExcelColumn label="Hacia" value="lugar" />
									<ExcelColumn label="Kilometraje inicial" value="kmInicial" />
									<ExcelColumn label="Kilometraje final" value="kmFinal" />
									<ExcelColumn label="Combinacion de rutas" value="combinacion" />
									<ExcelColumn label="Tarifa aplicada" value="tipoV" />
									<ExcelColumn label="Cantidad de trayectos" value="cantTrayec" />
									<ExcelColumn label="Precio aplicado" value="total" />
									<ExcelColumn label="Persona que solicita el servicio" value="cliente" />
									<ExcelColumn label="Codigo de empleado" value="numero_empleado" />
									<ExcelColumn label="Observaciones" value="comentario" />
								</ExcelSheet>
							</ExcelFile>
						</div>

					</div>

					<br />
					<div className="row">
						<div className="col-md-4 col-xs-6 col-sm-6 col-lg-2">
							<div className="form-group">
								<label>Empresa</label>
								<select
									className="form-control"
									value={empreUID}
									onChange={this.handleChangeEmpresa}
								>
									{empresas.map(emp => (
										<option key={emp.key} value={emp.key}>
											{emp.nombre}
										</option>
									))}
								</select>
							</div>
						</div>
						<div className="col-md-6 col-xs-6 col-sm-6 col-lg-5">
							<div className=" col-md-6">
								<label>Fecha inicio</label>
								<input type="date" className="form-control" max={this.state.fecha_actual} onChange={this.handleChangeDatePicker1}
									ref={input => { this.fecha1 = input; }} defaultValue={this.state.fecha_desde}
								/>
							</div>
						</div>

						<div className="col-md-6 col-xs-6 col-sm-6 col-lg-5">
							<div className="col-md-6">
								<label>Fecha fin</label>
								<input type="date" className="form-control" max={this.state.fecha_actual} onChange={this.handleChangeDatePicker2}
									ref={input => { this.fecha2 = input; }} min={this.state.fecha_minima} defaultValue={this.state.fecha_hasta}
								/>
							</div>
						</div>

					</div>
					<br />

					<div className="container">

						<BootstrapTable data={viajes}
							printToolBar={true}
							ref='table'
							pagination={true}
						>
							<TableHeaderColumn width={'150'} dataField='movil' isKey={true} dataSort={true} hidden>Nada</TableHeaderColumn>
							<TableHeaderColumn width={'250'} dataField='fechaRegistro' dataAlign="center" dataSort={true}>Fecha de Registro</TableHeaderColumn>
							<TableHeaderColumn width={'250'} dataField='empleado' dataSort={true}>Conductor</TableHeaderColumn>
							<TableHeaderColumn tdStyle={{ textAlign: 'center' }} width={'255'} dataField='centro' dataSort={true}>Centro de costos</TableHeaderColumn>
							<TableHeaderColumn width={'255'} dataField='areaDesc' dataSort={true}>Area de descargue</TableHeaderColumn>
							<TableHeaderColumn width={'120'} dataField='movil' dataSort={true}>Movil</TableHeaderColumn>
							<TableHeaderColumn width={'120'} dataField='vehiculo' dataSort={true}>Unidad</TableHeaderColumn>
							<TableHeaderColumn tdStyle={{ textAlign: 'center' }} width={'275'} dataField='numero' dataSort={true}>Cantidad de personas por viaje</TableHeaderColumn>
							<TableHeaderColumn width={'250'} dataField='personas' dataSort={true}>Nombres (pasajeros)</TableHeaderColumn>
							<TableHeaderColumn width={'250'} dataField='fechaIti' dataAlign='center' dataSort={true}>Hora inicio itinerada</TableHeaderColumn>
							<TableHeaderColumn width={'250'} dataField='fechaSubida' dataAlign='center' dataSort={true}>Hora inicio Real</TableHeaderColumn>
							<TableHeaderColumn width={'250'} dataField='horaSubida' dataAlign='center' dataSort={true}>Hora subida pasajeros</TableHeaderColumn>
							{/* <TableHeaderColumn width={'250'} dataField='horaBajada' dataAlign='center' dataSort={true}>Fecha Bajada pasajeros</TableHeaderColumn> */}
							<TableHeaderColumn width={'250'} dataField='fechaFti' dataAlign='center' dataSort={true}>Hora finalizacion itinerada</TableHeaderColumn>
							<TableHeaderColumn width={'250'} dataField='fechaBajada' dataAlign='center' dataSort={true}>Hora finalizacion Real</TableHeaderColumn>
							<TableHeaderColumn width={'150'} dataField='pago' dataAlign='center' dataSort={true}>Pago</TableHeaderColumn>
							<TableHeaderColumn width={'500'} dataField='desde' dataAlign='center' dataSort={true}>Desde</TableHeaderColumn>
							<TableHeaderColumn width={'500'} dataField='lugar' dataAlign='center' dataSort={true}>Hacia</TableHeaderColumn>

							<TableHeaderColumn width={'160'} dataField='kmInicial' dataSort={true}>Kilometraje inicial</TableHeaderColumn>
							<TableHeaderColumn width={'160'} dataField='kmFinal' dataSort={true}>Kilometraje final</TableHeaderColumn>
							<TableHeaderColumn width={'550'} dataField='combinacion' dataSort={true}>Combinacion de rutas</TableHeaderColumn>
							<TableHeaderColumn width={'150'} dataField='tipoV' dataAlign='center' dataSort={true}>Tarifa aplicada</TableHeaderColumn>
							<TableHeaderColumn width={'200'} dataField='cantTrayec' dataAlign='center' dataSort={true}>Cantidad de trayectos</TableHeaderColumn>
							<TableHeaderColumn width={'150'} dataField='total' dataAlign='center' dataSort={true}>Precio aplicado</TableHeaderColumn>
							<TableHeaderColumn width={'250'} dataField='cliente' dataAlign='center' dataSort={true}>Persona que solicita el servicio</TableHeaderColumn>
							<TableHeaderColumn width={'180'} dataField='numero_empleado' dataAlign='center' dataSort={true}>Codigo empleado</TableHeaderColumn>
							<TableHeaderColumn width={'180'} dataField='comentario' dataAlign='center' dataSort={true}>Observaciones</TableHeaderColumn>
						</BootstrapTable>
					</div>
				</div>
			);
		}
	}
}
export default ReporteOperacionalO;


// WEBPACK FOOTER //
// ./src/Components/Reportes/ReporteOperacionalO.js